import AttendanceModel, { isAttendance } from "src/models/AttendanceModel";
import ClassModel, { isClass } from "src/models/ClassModel";
import CustomerRequestModel, {
  isCustomerRequest,
} from "src/models/CustomerRequestModel";
import { isCustomerServiceItem } from "src/models/CustomerServiceItemModel";
import GroupRegistrationModel, {
  isGroupRegistration,
} from "src/models/GroupRegistrationModel";
import { InvoiceItemModel, isInvoiceItem } from "src/models/InvoiceItemModel";
import { isMembership } from "src/models/MembershipModel";
import MembershipOfferingModel, {
  isMembershipOffering,
} from "src/models/MembershipOfferingModel";
import OfferingModel, { isOffering } from "src/models/OfferingModel";
import OrganizationModel from "src/models/OrganizationModel";
import PrivateSerieAttendanceModel, {
  isPrivateSerieAttendance,
} from "src/models/PrivateSerieAttendanceModel";
import PrivateSerieModel, {
  isPrivateSerie,
} from "src/models/PrivateSerieModel";
import UserModel, { isUser } from "src/models/UserModel";
import { Level, PermissionType } from "types/code-generator";

export default function (
  items: Array<
    | ClassModel
    | OfferingModel
    | AttendanceModel
    | PrivateSerieAttendanceModel
    | PrivateSerieModel
    | CustomerRequestModel
    | GroupRegistrationModel
    | InvoiceItemModel
    | MembershipOfferingModel
  >,
  user: UserModel,
  organization: OrganizationModel
): any[] {
  let filteredItems = [...items];

  if (!organization.hasDepartments) {
    return filteredItems;
  }

  if (
    user?.level === Level.AccountOwner &&
    user?.permissions?.includes(PermissionType.ViewRoster)
  ) {
    return filteredItems;
  }

  filteredItems = filteredItems.filter((i) => {
    if (isClass(i) || isOffering(i)) {
      return (
        i.department && user.departments.find((d) => d.id === i.department.id)
      );
    } else if (isMembershipOffering(i)) {
      if (i.department) {
        return user.departments.find((d) => d.id === i.department.id);
      } else {
        return true;
      }
    } else if (isAttendance(i)) {
      return user.departments.find(
        (d) => i.class && i.class.department && i.class.department.id === d.id
      );
    } else if (isPrivateSerieAttendance(i)) {
      return user.departments.find(
        (d) => d.id === i.privateSerie.offering?.department?.id
      );
    } else if (isPrivateSerie(i)) {
      return user.departments.find((d) => d.id === i.offering.department?.id);
    } else if (isCustomerRequest(i)) {
      return user.departments.find(
        (d) => d.id === i.groupRegistration?.class.department.id
      );
    } else if (isGroupRegistration(i)) {
      console.log("user.departments", user.departments);
      console.log("i.class.department", i.class.department);
      return user.departments.find((d) => d.id === i.class.department.id);
    } else if (isInvoiceItem(i)) {
      return user.departments.find((d) => d.id === i.addon?.department?.id);
    } else if (isCustomerServiceItem(i)) {
      return true;
    } else if (isMembership(i)) {
      return true;
    } else if (isUser(i)) {
      return true;
    }

    return false;
  });

  return filteredItems;
}
